





















































































































































































































































/* eslint-disable */
import { Component, Vue, Watch } from 'vue-property-decorator';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Accordion from '@/components/Accordion.vue';
import api from '@/libs/api';
import { AxiosError } from 'axios';
import dayjs from 'dayjs';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Accordion,
  },
})
export default class OnepayTransDetail extends Vue {
  dayjs = dayjs;
  trx: any = {
    id: '',
    customerName: '',
    customerPhone: '',
    customerEmail: '',
    customerBillAddress: '',
    transactionDate: '',
    transactionExpire: '',
    transactionAmount: '',
    transactionFee: '',
    transactionFeature: '',
    itemDetail: [],
  };

  pay: {
    channelID: any,
    req_stamp: any,
    res_stamp: any,
    transactionStatus: any,
    transactionMessage: any,
    paymentStatus: any,
    paymentMessage: any,
    redirectData: any,
  }[] = []

  historyPayment: {
    history_id: any,
    merch_id: any,
    transaction_no: any,
    process: any,
    channel_id: any,
    api_channel: any,
    api_detail: any,
    api_time: any,
    stamp: any,
  }[] = []

  access: {
    ip: any,
    referer: any,
    user_agent: any,
    detail: any,
    stamp: any,
  }[] = []

  card_information: any = {
    card_holder_name: '',
    approval_code: '',
    card_Expiry: '',
    card_number: '',
  }
  async getTransactionDetail() {
    try {
      const { data } = await api.get('/onepay/transaction_detail', {
        params: {
          transaction_number: this.$route.params.trans_no
        },
      });

      if (data) {
        this.trx = data.trx;
        if (this.trx.itemDetail) {
          this.trx.itemDetail = JSON.parse(this.trx.itemDetail.replaceAll('&quot;', '"') || '[]');
          console.log(this.trx.itemDetail)
        }
        if (this.trx.transactionFeature) {
          this.trx.transactionFeature = JSON.parse(this.trx.transactionFeature.replaceAll('&quot;', '"') || '[]');
        }
        this.card_information = data.card_information || {};
        this.pay = data.pay;
        if (this.pay) {
          this.pay.forEach((val: any) => {
            val.redirectData = JSON.parse(val.redirectData.replaceAll('&quot;', '"') || '[]');
          })
        }
        this.historyPayment = data.history.PAYMENT;
        console.log('history', this.historyPayment);
        this.access = data.access;

      }

      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  mounted() {
    this.getTransactionDetail();
  }
}


